module.exports = __webpack_public_path__ + "img/open-camera.de662dab.png";